<oui-document-viewer
  class="slide-panel-viewer"
  [documentUrl]="fileUrls()"
  [showControls]="true">
  <div oui-document-controls>
    <div class="flex-horizontal flex-center justify-space-between">
      <div class="headline-6">{{ fileMetadata()?.typeDocumentLabel }}</div>
      <oui-button
        type="icon"
        color="secondary"
        (click)="filePanelService.closeFileViewer()">
        <oui-icon>close</oui-icon>
      </oui-button>
    </div>
    <div class="gap-8 flex-vertical padding-top-16">
      <div class="subtitle-1">{{ fileMetadata()?.fileName }}</div>
      @if (fileMetadata()?.dateDeDerniereModification) {
        <div class="body-2 color-on-surface-medium">
          Dernière mise à jour le {{ $safeNavigationMigration(fileMetadata()?.dateDeDerniereModification) | date: 'dd/MM/yyyy à HH:mm' }}
        </div>
      }
    </div>
    <div class="gap-16 flex-vertical padding-top-16">
      <oui-button
        type="contained"
        (click)="downloadDocument()">
        Télécharger
      </oui-button>
      @if (filePanelService.displayDelete() && !deleteForbidden()) {
        <div [ouiTooltip]="signatureInProgress() ? 'Suppression non possible tant que le document est en cours de signature.' : ''">
          <oui-button
            class="flex-horizontal"
            [disabled]="signatureInProgress() || isReadOnly()"
            type="outlined"
            (click)="openDialogDeleteDocument()">
            Supprimer
          </oui-button>
        </div>
      }
    </div>
  </div>
</oui-document-viewer>
